import Collection from "~/pages/collection";
import Community from "~/pages/communities/community";
import Home from "~/pages/index";
import HowDoesItWork from "~/pages/how-does-it-work";
import InfoPage from "~/pages/info";
import Router from "vue-router";
import Search from "~/pages/search";
import Vue from "vue";
import VueMeta from "vue-meta";
import { isEqual } from "lodash";

const CommunityEdit = () => import(/* webpackChunkName: "rich-text-editor" */ "~/pages/communities/community-edit");

Vue.use(Router);
Vue.use(VueMeta);

const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  }

  // Do not scroll to the top when only GET parameters change
  if (from && to.name === from.name && isEqual(to.params, from.params)) {
    return;
  }

  return { x: 0, y: 0 };
};

export default new Router({
  mode: "history",
  base: "/",
  linkActiveClass: "router-link-active",
  linkExactActiveClass: "router-link-exact-active",
  scrollBehavior,
  routes: [
    {
      path: "/en/how-does-it-work",
      component: HowDoesItWork,
      name: "how-does-it-work___en",
    },
    {
      path: "/hoe-werkt-het",
      component: HowDoesItWork,
      name: "how-does-it-work___nl",
    },
    {
      path: "/en/materials/search",
      component: Search,
      name: "materials-search___en",
      meta: {
        noAutoTrack: true,
      },
    },
    {
      path: "/materialen/zoeken",
      component: Search,
      name: "materials-search___nl",
      meta: {
        noAutoTrack: true,
      },
    },
    {
      path: "/en/my/collection/:id",
      component: Collection,
      name: "my-collection___en",
      meta: {
        editable: true,
      },
    },
    {
      path: "/mijn/collectie/:id",
      component: Collection,
      name: "my-collection___nl",
      meta: {
        editable: true,
      },
    },
    {
      path: "/en/my/community/:community",
      component: CommunityEdit,
      name: "my-community___en",
    },
    {
      path: "/mijn/community/:community",
      component: CommunityEdit,
      name: "my-community___nl",
    },
    {
      path: "/en/materials/:id(.*)/:slug(.*)",
      beforeEnter: (to, from) => {
        let domain = location.origin.replace("search.", "");
        if (location.href.includes("localhost")) {
          domain = process.env.VUE_APP_LOCAL_SEARCH_DOMAIN;
        }
        let material_id = to.params.id.replace(/\//g, '%252F');
        location.href = `${domain}/materials/${material_id}`;
      },
      name: "materials-id___en",
    },
    {
      path: "/materialen/:id(.*)/:slug(.*)",
      beforeEnter: (to, from) => {
        let domain = location.origin.replace("search.", "");
        if (location.href.includes("localhost")) {
          domain = process.env.VUE_APP_LOCAL_SEARCH_DOMAIN;
        }
        location.href = `${domain}/materials/${to.params.id}`;
      },
      name: "materials-id___nl",
    },
    {
      path: "/en/collections/:id?",
      component: Collection,
      name: "collections-id___en",
      meta: {
        editable: false,
      },
    },
    {
      path: "/collecties/:id?",
      component: Collection,
      name: "collections-id___nl",
      meta: {
        editable: false,
      },
    },
    {
      path: "/en/communities/:community",
      component: Community,
      name: "communities-community___en",
    },
    {
      path: "/communitys/:community",
      component: Community,
      name: "communities-community___nl",
    },
    {
      path: "/communities/:community",
      component: Community,
      name: "communities-community-legacy___nl",
    },
    {
      path: "/en/termsofservice",
      component: InfoPage,
      name: "tos___en",
      meta: {
        title_translation_key: "title-tos-info",
        html_translation_key: "html-tos-info",
      },
    },
    {
      path: "/servicevoorwaarden",
      component: InfoPage,
      name: "tos___nl",
      meta: {
        title_translation_key: "title-tos-info",
        html_translation_key: "html-tos-info",
      },
    },
    {
      path: "/en/institutions",
      component: InfoPage,
      name: "institutions___en",
      meta: {
        title_translation_key: "title-institutions-info",
        html_translation_key: "html-institutions-info",
      },
    },
    {
      path: "/instellingen",
      component: InfoPage,
      name: "institutions___nl",
      meta: {
        title_translation_key: "title-institutions-info",
        html_translation_key: "html-institutions-info",
      },
    },
    {
      path: "/en/",
      component: Home,
      name: "index___en",
    },
    {
      path: "/",
      component: Home,
      name: "index___nl",
    },
    {
      path: "/oidc-callback",
      component: () => import("@/pages/oidc-callback.vue"),
    },
  ],
  fallback: false,
});
